var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"flat":"","icon":"","color":"#444444"}},[_c('v-icon',[_vm._v("share")])],1),_vm._v("\n  "+_vm._s(_vm.share)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }